import { OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

export class CustomOperators {
  static filterNonNullAndNonEmpty<T>(): OperatorFunction<T | null | undefined, T> {
    return source$ =>
      source$.pipe(filter((value): value is T => value !== null && value !== undefined && (!Array.isArray(value) || value.length > 0)));
  }
}
